import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Activity } from 'src/app/models/activity/activity';
import { Calendar } from 'src/app/models/calendar/calendar';
import { HttpService } from 'src/app/services/http/http.service';
import { ScheduleTransformer } from '@models/calendar/schedule/schedule';
import moment from 'moment';
import { StaffBasicDto } from 'src/app/models/staff/staff-basic-dto';
import { ScheduleCancel } from '../models/schedule-cancel';


@Injectable({
    providedIn: 'root'
})
export class ActivitiesService extends HttpService {
    private selectedDate: Date = new Date();

    setNewDate(selectedDate: Date): void {
        this.selectedDate = selectedDate;
    }

    getDate(): Date {
        return this.selectedDate;
    }

    calendarManager(): Observable<Calendar[]> {
        const url = 'calendar/manager';
        const params = this.buildGetParams(new HttpParams({ fromString: this.dateToString() }));

        return this.get(url, { app: 'booking', version: 2.2 }, params);
    }

    getActivities(): Observable<Activity[]> {
        const url = 'activities';

        return this.get(url, { app: 'booking', version: 2 });
    }

    getStaff(): Observable<StaffBasicDto[]> {
        const url = 'staff/search';

        return this.get(url, {app: 'center', version: 1});
    }

    dateToString(): string {
        return `startDateTime=${moment(this.selectedDate).format('YYYY-MM-DD')}&endDateTime=${moment(this.selectedDate).format('YYYY-MM-DD')}`;
    }

    cancelSchedule(scheduleState: ScheduleCancel): Observable<any> {
        const url = `schedules/${scheduleState.id}/cancel`;

        return this.post(url, { app: 'booking', version: 2 }, scheduleState);
    }

    updateSchedule(schedule: ScheduleTransformer): Observable<any> {
        const url = `schedules/${schedule.id}`;

        return this.put(url, { app: 'booking', version: 2 }, schedule);
    }

}
